import { CalculateTourEnv } from '@/domain/impact-calculate-tour/entities/calculate-tour-env.entity';
import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';
import { ProjectScoresDetailsData } from '@/ui/pages/app/components/project-page/ProjectScoresDetails/ProjectScoresDetails.types';
import {
  formatUnit,
  getEnvSectionName,
  getEnvTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareProjectTourScoreDetailsDataEnv(
  calculateEnv: CalculateTourEnv,
): ProjectScoresDetailsData[] {
  return [
    {
      title: getEnvTopicName(EnvTopic.EQUIPMENT_AND_SCENOGRAPHY),
      value: calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.score,
      maxValue: calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEnvSectionName(EnvSection.SCENOGRAPHY),
          value:
            calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
              .SCENOGRAPHY.score,
          unit: formatUnit(
            calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
              .SCENOGRAPHY.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
              .SCENOGRAPHY.maxScore,
          topic: 'EQUIPMENT_AND_SCENOGRAPHY',
          type: 'env',
          section: 'SCENOGRAPHY',
        },
        {
          name: getEnvSectionName(EnvSection.TECHNIQUE),
          value:
            calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
              .TECHNIQUE.score,
          unit: formatUnit(
            calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
              .TECHNIQUE.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.EQUIPMENT_AND_SCENOGRAPHY.sections
              .TECHNIQUE.maxScore,
          topic: 'EQUIPMENT_AND_SCENOGRAPHY',
          type: 'env',
          section: 'TECHNIQUE',
        },
      ],
    },
    {
      title: getEnvTopicName(EnvTopic.FOOD_BEVERAGES),
      value: calculateEnv.general.topics.FOOD_BEVERAGES.score,
      maxValue: calculateEnv.general.topics.FOOD_BEVERAGES.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEnvSectionName(EnvSection.CATERING),
          value:
            calculateEnv.general.topics.FOOD_BEVERAGES.sections.CATERING.score,
          unit: formatUnit(
            calculateEnv.general.topics.FOOD_BEVERAGES.sections.CATERING
              .maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.FOOD_BEVERAGES.sections.CATERING
              .maxScore,
          topic: 'FOOD_BEVERAGES',
          type: 'env',
          section: 'CATERING',
        },
        {
          name: getEnvSectionName(EnvSection.DISHES),
          value:
            calculateEnv.general.topics.FOOD_BEVERAGES.sections.DISHES.score,
          unit: formatUnit(
            calculateEnv.general.topics.FOOD_BEVERAGES.sections.DISHES.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.FOOD_BEVERAGES.sections.DISHES.maxScore,
          topic: 'FOOD_BEVERAGES',
          type: 'env',
          section: 'DISHES',
        },
      ],
    },
    {
      title: getEnvTopicName(EnvTopic.RESOURCES_POLLUTION),
      value: calculateEnv.general.topics.RESOURCES_POLLUTION.score,
      maxValue: calculateEnv.general.topics.RESOURCES_POLLUTION.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEnvSectionName(EnvSection.WATER_AND_WASTE),
          value:
            calculateEnv.general.topics.RESOURCES_POLLUTION.sections
              .WATER_AND_WASTE.score,
          unit: formatUnit(
            calculateEnv.general.topics.RESOURCES_POLLUTION.sections
              .WATER_AND_WASTE.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.RESOURCES_POLLUTION.sections
              .WATER_AND_WASTE.maxScore,
          topic: 'RESOURCES_POLLUTION',
          type: 'env',
          section: 'WATER_AND_WASTE',
        },
      ],
    },
    {
      title: getEnvTopicName(EnvTopic.COMMUNICATION),
      value: calculateEnv.general.topics.COMMUNICATION.score,
      maxValue: calculateEnv.general.topics.COMMUNICATION.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEnvSectionName(EnvSection.PHYSICAL_COMMUNICATION),
          value:
            calculateEnv.general.topics.COMMUNICATION.sections
              .PHYSICAL_COMMUNICATION.score,
          unit: formatUnit(
            calculateEnv.general.topics.COMMUNICATION.sections
              .PHYSICAL_COMMUNICATION.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.COMMUNICATION.sections
              .PHYSICAL_COMMUNICATION.maxScore,
          topic: 'COMMUNICATION',
          type: 'env',
          section: 'PHYSICAL_COMMUNICATION',
        },
        {
          name: getEnvSectionName(EnvSection.DIGITAL_COMMUNICATION),
          value:
            calculateEnv.general.topics.COMMUNICATION.sections
              .DIGITAL_COMMUNICATION.score,
          unit: formatUnit(
            calculateEnv.general.topics.COMMUNICATION.sections
              .DIGITAL_COMMUNICATION.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.COMMUNICATION.sections
              .DIGITAL_COMMUNICATION.maxScore,
          topic: 'COMMUNICATION',
          type: 'env',
          section: 'DIGITAL_COMMUNICATION',
        },
      ],
    },
    {
      title: getEnvTopicName(EnvTopic.PUBLIC_ENGAGEMENT),
      value: calculateEnv.general.topics.PUBLIC_ENGAGEMENT.score,
      maxValue: calculateEnv.general.topics.PUBLIC_ENGAGEMENT.maxScore,
      refValue: NaN,
      viewMode: 'semi-circle',
      detailsValues: [
        {
          name: getEnvSectionName(EnvSection.PARTNERSHIP_STRATEGY),
          value:
            calculateEnv.general.topics.PUBLIC_ENGAGEMENT.sections
              .PARTNERSHIP_STRATEGY.score,
          unit: formatUnit(
            calculateEnv.general.topics.PUBLIC_ENGAGEMENT.sections
              .PARTNERSHIP_STRATEGY.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.PUBLIC_ENGAGEMENT.sections
              .PARTNERSHIP_STRATEGY.maxScore,
          topic: 'PUBLIC_ENGAGEMENT',
          type: 'env',
          section: 'PARTNERSHIP_STRATEGY',
        },
        {
          name: getEnvSectionName(EnvSection.PUBLIC_INFORMATION),
          value:
            calculateEnv.general.topics.PUBLIC_ENGAGEMENT.sections
              .PUBLIC_INFORMATION.score,
          unit: formatUnit(
            calculateEnv.general.topics.PUBLIC_ENGAGEMENT.sections
              .PUBLIC_INFORMATION.maxScore,
          ),
          maxScore:
            calculateEnv.general.topics.PUBLIC_ENGAGEMENT.sections
              .PUBLIC_INFORMATION.maxScore,
          topic: 'PUBLIC_ENGAGEMENT',
          type: 'env',
          section: 'PUBLIC_INFORMATION',
        },
      ],
    },
  ];
}
